import { Box, Divider } from "@mui/material";
import HeaderTabsBar from "./ChartSectionHeader";
import PlotComponent from "./plot/plot";
import MainTable from "./MainTable";
import TableComponent from "./TableComponent.jsx";
import SubPlots from "./subPlots/SubPlots.jsx";
import Histogram from "./histogram/Histogram.jsx";
import { useEffect, useMemo, useRef, useState } from "react";
import { useNavigate } from "react-router-dom";
import { manageDataRoute } from "../../../routes/routeConstants.js";

const VisualizationTableSubChartAndOtherData = ({
  index,
  typeOfMode,
  batchState,
  activeChart,
  currentChartConfigState,
  product,
  site,
  unitOfOperation,
  setSaveDialogOpen,
  saving,
  parameterState,
  firstChartIdToShowSave,
  showSummaryTable,
  showViolationTable,
  handleBatchIdClick,
  isRestoredStateForReturn,
}) => {
  const [activeTab, setActiveTab] = useState(
    isRestoredStateForReturn ? "tables" : "chart",
  );
  const plotRef = useRef(null);
  const [open, setOpen] = useState(false);
  const navigate = useNavigate();

  useEffect(() => {
    if (typeOfMode === "create") {
      if (parameterState?.plotType) {
        if (
          (parameterState.plotType !== "pp_chart" ||
            parameterState.plotType !== "process_capability") &&
          activeTab === "subplots"
        ) {
          setActiveTab("chart");
        }
      }
    }
  }, [parameterState?.plotType, typeOfMode]);

  const headers = useMemo(
    () => activeChart?.summaryTableTitles || [],
    [activeChart?.summaryTableTitles],
  );

  const violationTableHeaders = useMemo(
    () => activeChart?.violationTableTitles || [],
    [activeChart?.violationTableTitles],
  );

  const memoizedHistogramData = useMemo(
    () => activeChart?.histogramData,
    [activeChart?.histogramData],
  );

  // const handleBatchIdClick = (batchId) => {
  //   navigate(`/${manageDataRoute.reviewBatches}`, {
  //     state: { batchId, unitOfOperation, site, product },
  //   });
  // };

  useEffect(() => {
    // Reset to chart tab when activeChart changes
    console.log("Active chart changed, resetting to chart tab", activeChart);
  }, [activeChart]);
  return (
    <Box
      sx={{
        height: "100%",
        display: "flex",
        flexDirection: "column",
        overflow: "hidden",
      }}
    >
      {/* HEADER */}
      <HeaderTabsBar
        activeTab={activeTab}
        setActiveTab={setActiveTab}
        state={activeChart}
        currentChartConfigState={currentChartConfigState}
        configSetIds={activeChart?.configSetIds || {}}
        // saving={saving}
        // disableAllFields={disableAllFields}
        // setSaveDialogOpen={setSaveDialogOpen}
        setOpen={setOpen}
        index={index}
        firstChartIdToShowSave={firstChartIdToShowSave}
        chartId={activeChart?.id}
      />

      {/* BODY */}
      <Box
        sx={{
          flex: 1,
          overflow: "auto",
          display: "flex",
          flexDirection: "column",
        }}
      >
        {activeTab === "chart" && (
          <>
            <Box
              sx={{
                minHeight: 420,
                flexShrink: 0,
              }}
            >
              <PlotComponent
                // plotKey={plotKey}
                plotKey={activeChart?.id || `plot-${Date.now()}`}
                data={activeChart?.parsedData?.data}
                layout={activeChart?.parsedData?.layout}
                config={activeChart?.parsedData?.config}
                plotRef={plotRef}
                plotTitles={activeChart?.titles}
                fullHeightProps={true}
              />
            </Box>

            {showSummaryTable && (
              <Box
              // sx={{ mt: 2 }}
              >
                <MainTable
                  headers={headers}
                  data={activeChart?.tableData}
                  title="Summary Table"
                  plotType={parameterState?.plotType}
                />
              </Box>
            )}

            {showViolationTable &&
              activeChart?.violationTableData?.length > 0 && (
                <Box sx={{ mt: 2 }}>
                  <MainTable
                    headers={violationTableHeaders}
                    data={activeChart?.violationTableData}
                    title="Nelson Rule Violations"
                  />
                </Box>
              )}
          </>
        )}

        {activeTab === "tables" && (
          <Box sx={{ flex: 1 }}>
            <TableComponent
              rawData={activeChart?.rawData}
              product={product}
              site={site}
              unitOfOperation={unitOfOperation}
              parameterName={
                activeChart?.parameterState?.parameter?.label || ""
              }
              handleBatchIdClick={handleBatchIdClick}
              uniqueBatches={activeChart?.uniqueBatches || []}
            />
          </Box>
        )}

        {activeTab === "subplots" && (
          <>
            <Box sx={{ flexShrink: 0 }}>
              <SubPlots
                data={activeChart?.subPlotsData}
                setOpen={setOpen}
                open={open}
              />
            </Box>
            <Divider sx={{ my: 2 }} />
            {/* showing table from main data as data in sub plot is just splitted from main table and in subplot we want to show whole data instead of splitted data in subplots */}
            <MainTable headers={headers} data={activeChart?.tableData} />
          </>
        )}

        {activeTab === "histogram" && (
          <Box sx={{ flex: 1 }}>
            <Histogram data={memoizedHistogramData} />
          </Box>
        )}
      </Box>
    </Box>
  );
};

export default VisualizationTableSubChartAndOtherData;
